export { formatMoney, formatDate } from "src/features/deals/constants"

export const BOOKING_STATUS_BADGE = {
  reserved:  "secondary",
  confirmed: "info",
  completed: "success",
  cancelled: "outline",
}

export const BOOKING_STATUS_LABEL = {
  reserved:  "Reserved",
  confirmed: "Confirmed",
  completed: "Completed",
  cancelled: "Cancelled",
}

export const INSTALLMENT_STATUS_STYLE = {
  due:      { label: "Due", cls: "bg-slate-100 text-slate-600" },
  partial:  { label: "Partial", cls: "bg-amber-100 text-amber-700" },
  paid:     { label: "Paid", cls: "bg-emerald-100 text-emerald-700" },
  overdue:  { label: "Overdue", cls: "bg-red-100 text-red-700" },
}

export const PAYMENT_MODES = [
  { value: "neft", label: "NEFT" },
  { value: "rtgs", label: "RTGS" },
  { value: "cheque", label: "Cheque" },
  { value: "upi", label: "UPI" },
  { value: "cash", label: "Cash" },
  { value: "card", label: "Card" },
  { value: "online", label: "Online" },
]
